import { Controller } from '@hotwired/stimulus'

export default class RebrandingRegistrationController extends Controller {
  static targets = [
    'referrerCodeInput',
    'sponsorshipTerms',
    'sponsorshipCheckbox'
  ];

  connect() {
    this.toggleSponsorshipTerms();
  }

  referrerCodeChanged() {
    this.toggleSponsorshipTerms();
  }

  toggleSponsorshipTerms() {
    const referrerCode = this.referrerCodeInputTarget.value.trim();

    if (referrerCode.length > 0) {
      this.sponsorshipTermsTarget.classList.remove('d-none');
      this.sponsorshipCheckboxTarget.required = true;
    } else {
      this.sponsorshipTermsTarget.classList.add('d-none');
      this.sponsorshipCheckboxTarget.required = false;
      this.sponsorshipCheckboxTarget.checked = false;
    }
  }
}
